import React, {useEffect, useState, useCallback, useRef} from "react";
import { Row, Col, Tab, Tabs, Button } from "react-bootstrap";
import Breadcrumb from "../../../components/Breadcrumb";
import DocEventSearchTable from "./doc-event-search-table";
import UiPaginate from "../../../components/uiPaginate/UiPaginate";
import { searchDocEvent } from "../../../services/SearchDocumentService";
import {FiActivity} from "react-icons/fi";

const DEFAULT_PAGINATION = {
    'pagination.page': 0,
    'pagination.limit': 5
};

const STATUS_TABS = [
    { key: 'T', label: 'Todos' },
    { key: 'PROCESSED', label: 'Concluído' },
    { key: 'WAIT', label: 'Aguardando' },
    { key: 'ERROR', label: 'Erros' },
];

const DocEventSearchRoot = () => {
    const [loading, setLoading] = useState(false);
    const [pager, setPager] = useState({ pagination: {}, results: [] });
    const [filters, setFilters] = useState({});
    const [autoRefresh, setAutoRefresh] = useState(false);

    const filtersRef = useRef(filters);
    useEffect(() => {
        filtersRef.current = filters;
    }, [filters]);

    const updateFilter = (field, value) => {
        setFilters(prev => {
            const updated = { ...prev };
            if (value === 'null') {
                delete updated[field];
            } else {
                updated[field] = value;
            }
            return updated;
        });
    };

    const performSearch = useCallback(async (pageOverrides = {}, filterOverrides = {}) => {
        if (loading) return;
        setLoading(true);
        try {
            let queryFilter = Object.keys(filterOverrides).length ? filterOverrides : filtersRef.current;

            const payload = {
                ...DEFAULT_PAGINATION,
                ...pageOverrides,
                ...queryFilter
            };

            const response = await searchDocEvent(payload);
            setPager(response.data);
        } catch (error) {
            console.error("Erro ao buscar eventos:", error);
        } finally {
            setLoading(false);
        }
    }, [filters, loading]);

    const handleStatusChange = (status) => {
        const updatedFilters = { ...filters };

        if (status === 'T') {
            delete updatedFilters.status;
        } else {
            updatedFilters.status = status;
        }

        setFilters(updatedFilters);
        performSearch({ 'pagination.page': 0 }, updatedFilters);
    };

    useEffect(() => {
        handleStatusChange('T');
    }, []);

    useEffect(() => {
        if (!autoRefresh) return;

        const interval = setInterval(() => {
            performSearch();
        }, 5000);

        return () => clearInterval(interval);
    }, [autoRefresh, performSearch]);


    return (
        <div>
            <Breadcrumb
                routeSegments={[
                    {
                        name: "Arquivos"
                    },
                    {
                        name: "Processamento",
                        popover: "são processamentos de OCR, classificação inteligente e outros recursos.",
                        skipRepeat: true
                    }
                ]}
            />

            <div className="mb-4">
                <Row>
                    <Col>
                        <Row className="mb-3">
                            <Col md={6}>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Pesquisar"
                                    onChange={(e) => updateFilter('q', e.target.value)}
                                />
                            </Col>
                            <Col md={4} />
                            <Col md={2} className="mt-3 mt-md-0">
                                <Button
                                    variant="primary"
                                    className="btn w-100"
                                    onClick={() => performSearch()}
                                    disabled={loading}
                                >
                                    Pesquisar &nbsp;<i className="i-Magnifi-Glass1"></i>
                                </Button>
                            </Col>

                            <Col md={4} className="d-flex align-items-center gap-2 mt-4">
                                <input
                                    type="checkbox"
                                    id="autoRefresh"
                                    className="form-check-input"
                                    checked={autoRefresh}
                                    onChange={(e) => setAutoRefresh(e.target.checked)}
                                />
                                <label htmlFor="autoRefresh" className="form-check-label">
                                    Atualizar Lista Automaticamente
                                </label>
                                {autoRefresh && <FiActivity className="text-success" title="Atualização automática ativa" />}
                            </Col>

                        </Row>

                        <Tabs defaultActiveKey="T" id="status-tabs">
                            {STATUS_TABS.map(({ key, label }) => {
                                let badge = null;

                                if (key === 'WAIT') {
                                    badge = (
                                        <span className="badge bg-warning text-dark ms-2">
          {pager?.summary?.WAIT ?? 0}
        </span>
                                    );
                                }

                                if (key === 'ERROR') {
                                    badge = (
                                        <span className="badge bg-danger ms-2">
          {pager?.summary?.ERROR ?? 0}
        </span>
                                    );
                                }

                                return (
                                    <Tab
                                        key={key}
                                        eventKey={key}
                                        title={
                                            <span className="d-flex align-items-center">
            {label} {badge}
          </span>
                                        }
                                        onEnter={() => handleStatusChange(key)}
                                    />
                                );
                            })}
                        </Tabs>

                        {pager.results.length > 0 && (
                            <div style={{marginTop: '-40px'}}>
                                <DocEventSearchTable results={pager.results} />
                                <UiPaginate
                                    pager={pager}
                                    onPageChange={({ selected }) =>
                                        performSearch({ 'pagination.page': selected })
                                    }
                                />
                            </div>
                        )}
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default DocEventSearchRoot;